import { render, staticRenderFns } from "./PanelBody.vue?vue&type=template&id=3a5c66f5&lang=pug&"
import script from "./PanelBody.vue?vue&type=script&lang=js&"
export * from "./PanelBody.vue?vue&type=script&lang=js&"
import style0 from "./PanelBody.vue?vue&type=style&index=0&id=3a5c66f5&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports